export const authTokenLocalStorageKey = "token";
export const groups = {
  EMPLOYEES: "Employees",
  DEV_TEAM: "Development Team",
  ADMIN_TEAM: "Admin Team",
  COACHING_TEAM: "Coaching Team",
  STUDENTS: "Students",
  PARENTS: "Parents",
};
